import { AbstractModel } from './abstract-model';

/**
 * Ajuda de uma rotina do Hábil 10 — o texto que o botão de ajuda mostra no ERP.
 *
 * Os campos vêm de duas origens e o comportamento é diferente:
 *
 * - **derivados do código** (`titulo`, `nomeNoMenu`, `modulo`, `ondeFica`, `rota`,
 *   `permissao`, `tipo`, `acoes`, `relacionadas`): reescritos a cada publicação do
 *   catálogo. Editar aqui não adianta — a próxima importação sobrescreve.
 * - **curados** (`resumo`, `quandoUsar`, `conteudo`): escritos por gente. Quando
 *   salvos por esta tela, `editadoNaCentral` fica ligado e a importação passa a
 *   preservá-los.
 */
export class AjudaRotina extends AbstractModel {
  /** Identificador da rotina no catálogo. É a chave por onde o ERP pergunta. */
  rotina: string;

  // derivados do código
  titulo: string;
  nomeNoMenu: string;
  modulo: string;
  ondeFica: string;
  rota: string;
  permissao: string;
  tipo: string;
  /** JSON das ações que a tela oferece. */
  acoes: string;
  /** JSON das rotinas relacionadas. */
  relacionadas: string;

  // curados
  resumo: string;
  quandoUsar: string;
  /** Markdown das seções "Como fazer" e "Atenção". Vazio nas fichas curtas. */
  conteudo: string;
  profundidade: string;

  // controle
  editadoNaCentral: boolean;
  publicado: boolean;
  importadoEm: Date;
}
